type RuntimeEnvKey =
  | 'VITE_GATEWAY_URL'
  | 'VITE_PORTAL_API_URL'
  | 'VITE_IDENTITY_LOGIN_URL'
  | 'VITE_THIS_URL'
  | 'VITE_IDENTITY_LOGIN_URL_REDIRECT'
  | 'VITE_SENTRY_DSN'
  | 'VITE_SENTRY_ENV'
  | 'VITE_APP_VERSION'
  | 'VITE_STRIPE_PK'
  | 'VITE_CHATBOT_URL'
  | 'VITE_COMUNIDAD_URL'
  | 'VITE_MAPBOX_TOKEN'

declare global {
  interface Window {
    __ENV__?: Partial<Record<RuntimeEnvKey, string>>
  }
}

/**
 * Lee una variable de entorno en runtime.
 * Prioridad: window.__ENV__ (Docker) › import.meta.env (dev local con Vite).
 */
export function getEnv(key: RuntimeEnvKey): string | undefined {
  return window.__ENV__?.[key] ?? (import.meta.env[key] as string | undefined)
}

/** Fallback local de la URL del REST del portal-server (dev con portal-server en :3001). */
const PORTAL_API_FALLBACK = 'http://localhost:3001'

/**
 * URL base del REST propio del portal-server, sin barra final.
 *
 * Se resuelve en RUNTIME vía `getEnv` (window.__ENV__ que inyecta el
 * contenedor al arrancar), NO con `import.meta.env` directo: la imagen Docker
 * es única para todos los entornos y las VITE_* llegan al arrancar, no en el
 * build. Leer `import.meta.env` aquí horneaba un valor vacío y caía al
 * fallback localhost en la nube (portaldev pegándole a localhost:3001).
 *
 * El fallback a localhost:3001 solo aplica en desarrollo local.
 */
export function getPortalApiBase(): string {
  const url = getEnv('VITE_PORTAL_API_URL') ?? PORTAL_API_FALLBACK
  return url.replace(/\/$/, '')
}
